/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extraction_Status_RequestedInputs */

const en_extraction_status_requested = /** @type {(inputs: Extraction_Status_RequestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Being read`)
};

/**
* | output |
* | --- |
* | "Being read" |
*
* @param {Extraction_Status_RequestedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const extraction_status_requested = /** @type {((inputs?: Extraction_Status_RequestedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extraction_Status_RequestedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_extraction_status_requested(inputs)
});